import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { ReactNode } from 'react';
import {
  BenefitInfoTextExtensionInterface,
  BenefitInfoTextProps,
  BenefitLinkProps,
  BenefitSpecialLinkProps,
} from '../../../../extension/interface/benefit-info-text.extension.interface';
import { NonCashBenefitInfoText } from '../../../../page/benefit/NonCashBenefitInfoText';

export class FlexBenefitInfoTextExtension extends BenefitInfoTextExtensionInterface {
  getBenefitLinks(): BenefitLinkProps | undefined {
    return {
      managerSpecific: 'https://www.youtube.com/watch?v=lrU3NFXSIyA',
      appSpecific: 'https://www.youtube.com/watch?v=HB8dYjkHUGk',
    };
  }

  getBenefitMoreLinks(): BenefitSpecialLinkProps | undefined {
    return undefined;
  }

  getHelpCenterLink(): string | undefined {
    return 'https://support.probonio.de/hc/de/sections/21322492869522--Flex-Budget';
  }

  renderAdditionalContent(props: BenefitInfoTextProps): ReactNode {
    const shouldRenderNonCash = props.benefit === BenefitDTOBenefitEnum.Flex && props.hasNonCashBenefits;
    return shouldRenderNonCash ? <NonCashBenefitInfoText /> : null;
  }
}
